import { PatientPortalSystemOptions } from 'types/patient-portal-system.types';

// Function to get the Patient Portal System ID from local storage
export const getPatientPortalSystemId =
  (): PatientPortalSystemOptions | null => {
    const localStorageSystemId = localStorage.getItem(
      'PATIENT_PORTAL_SYSTEM_ID',
    ) as PatientPortalSystemOptions | null;

    return localStorageSystemId;
  };
